module.exports = __webpack_public_path__ + "img/text-resource.svg";